import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/athlete-proposition-bet.module.scss";
import {BookmakerActionButton} from "../../../core/components/odds/bookmaker-action-button/bookmaker-action-button";
import {useBookieClick} from "../../../infrastructure/hooks/useBookieClick";
import {APP} from "../../../core/app/consts";
import {WIDGET_TYPES} from "../../../core/consts";
import {PREDICTION_WIDGET} from "../../../widgets/prediction-widget/predictions-widget.consts";
import {PROPOSITION_BETS} from "../../../widgets/proposition-bets-widget/proposition-bets-widgets.consts";

export const AthletePropositionBetModuleButton = observer(({controller, row, betsImpressionParams}) => {
  const {state, device, terms, config} = controller;
  const {isSmallView} = device;
  const {WIDGET_ODDS_BY_DEFAULT} = terms;
  const {bookmaker, game, currentLinkModel} = state;
  const {lineTypeId} = row;
  const {source} = config;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    urlLink: bookmaker?.link,
    hasOdds: !!bookmaker,
    marketType: lineTypeId,
    status: game?.statusGroup,
    widget: APP.ANALYTICS.WIDGET_TYPES[WIDGET_TYPES.athletePropositionBet],
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.tooltip,
    subSource: PREDICTION_WIDGET.TABS_LABEL.props,
    buttonType: PROPOSITION_BETS.ANALYTICS.BOOKIE_BUTTON_TYPE.betNow,
    currentLinkModelName: currentLinkModel.name,
    source
  });

  const betNowButtonProps = {
    controller,
    bookmaker,
    isSmallView,
    bookieHrefModel,
    betsImpressionParams,
    className: classNames(styles.button),
    label: WIDGET_ODDS_BY_DEFAULT,
    withLogo: true,
    supportColor: true,
    bookmakerSrc: new bookmaker.transparentLogoType({width: 52, height: 12}, {id: bookmaker.id}),
    shouldRenderActionButton: bookmaker?.actionButton,
    onClick: () => onBookieClick(),
  }

  return <div className={classNames(styles.button_container)}>
    <BookmakerActionButton {...betNowButtonProps}/>
  </div>
});
